(function () {
	/******************
		* This is a helper method to make adding events to elements easier.
		* It allows you to pass an element, a CSS selector string, or an array of elements/nodelist as the element parameter
		* It can take more than one event at a time, so you can wireup multiple events in a single line.
		* It also has short hand for comment events, like on press of enter, or press of escape
		* All events can be modified to prevent default or stop propagation
		* Usage Examples:
			blue.meth.addEvents(element, 'click', function() { // stuff to do }) // add click to an element
			blue.meth.addEvents(window, 'resize orientationchange load', function() { // stuff to do }) // add several events to window
			blue.meth.addEvents(element, 'enter esc', function() { // stuff to do }) // add keyup -> enter and keyup -> escape to element
			blue.meth.addEvents('.selector', 'click.prevent escape.stop.prevent', function() { // stuff to do }) // add click e.preventDefault() and escape e.stopPropagation() e.preventDefault() to all elements that match .selector
	******************/
	// class to build the event chain
	class EventChain {
		stop() {
			return (this.event.stopPropagation(), true)
		}
		prevent() {
			return (this.event.preventDefault(), true)
		}
		enter() {
			return (this.event.key == 'Enter' ? (this.valid = true) : (this.valid = false))
		}
		esc() {
			return (this.event.key == 'Escape' ? (this.valid = true) : (this.valid = false))
		}
		get type() {
			switch (this.event_string[0]) {
				case 'enter':
				case 'esc':
					return 'keydown'
				default:
					return this.event_string[0]
			}
		}
		set create(data) {
			this.event = data.event
			this.event_string.every(mod => (typeof this[mod] === 'function' ? this[mod]() : true))
			this.valid ? data.listener.call(data.this, data.event) : false
		}
		constructor(event_string) {
			this.event_string = event_string.split('.')
			this.valid = true
		}
	}

	// wire up the events with the compiled event chins
	const addEvents = blue.meth.addEvents = (ele, events, listener) => {
		const elements = typeof ele == 'string' ? [...document.querySelectorAll(ele)] : ele.length ? [...ele] : [ele]
		events = events.split(/[,;\s]/gi)

		elements.forEach(element => {
			events.forEach(event_string => {
				let eventChain = new EventChain(event_string)
				element.addEventListener(eventChain.type, function (event) {
					eventChain.create = { event, listener, this: this }
				})
			})
		})
	}
})();